import { useId } from "react";
import { SectionTitle } from "@sprout/typography.tsx";
import { MultiCheckbox } from "@sprout/checkbox.tsx";
import Button from "@sprout/button.tsx";
import CaretIcon from "@sprout/icons/caret.tsx";
import { SpecializedMultiSelectFilterProps } from "@components/job_search/filters/multi_select_filter.tsx";
import { Drawer, DrawerContent, DrawerTrigger } from "@components/ui/drawer.tsx";

export const MobileMultiSelectFilter = ({
  buttonText,
  name,
  onSelect,
  options,
  values,
}: SpecializedMultiSelectFilterProps) => {
  const id = useId();

  return (
    <Drawer>
      <DrawerTrigger asChild>
        <Button size="medium" className="inline-flex items-center justify-between gap-1">
          <div className="flex items-center justify-center gap-1 w-full">
            {buttonText}
            <CaretIcon size="sm" color="green" />
          </div>
        </Button>
      </DrawerTrigger>
      <DrawerContent className="gap-2">
        <SectionTitle>{name}</SectionTitle>
        <MultiCheckbox
          id={id}
          options={options}
          isMulti={true}
          onSelect={onSelect}
          values={values}
        />
      </DrawerContent>
    </Drawer>
  );
};
